export const formatEuro = (value) => {
  if (typeof value !== 'number') return '-';

  const hasDecimals = Math.round(value * 100) % 100 !== 0;

  return value.toLocaleString('fr-FR', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }) + ' €';
};

/**
 * Normalise une date vers format ISO (YYYY-MM-DD) pour Airtable
 * @param {string} dateStr - Date en format variable (DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY, etc.)
 * @returns {string} Date au format ISO (YYYY-MM-DD)
 */
export const normalizeDate = (dateStr) => {
  if (!dateStr) return '';

  // DD/MM/YYYY ou DD-MM-YYYY ou DD.MM.YYYY → YYYY-MM-DD
  const dmy = dateStr.match(/^(\d{2})[/\-.](\d{2})[/\-.](\d{4})$/);
  if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;

  // YYYY/MM/DD ou YYYY-MM-DD ou YYYY.MM.DD → YYYY-MM-DD
  const ymd = dateStr.match(/^(\d{4})[/\-.](\d{2})[/\-.](\d{2})$/);
  if (ymd) return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;

  return dateStr; // Déjà ISO ou format non reconnu
};

/**
 * Formate une date ISO pour affichage utilisateur (DD/MM/YYYY)
 * @param {string} isoDate - Date au format ISO (YYYY-MM-DD)
 * @returns {string} Date au format DD/MM/YYYY
 */
export const formatDateForDisplay = (isoDate) => {
  if (!isoDate) return '';
  const parts = isoDate.split('-');
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return isoDate;
};